import 'regenerator-runtime/runtime';

export const HttpClient = {
  AsyncPostRequest: (actionUrl, data, method) => {
    return new Promise(function (resolve, reject) {
      if (process.env.NODE_ENV === "development" && method === "POST") {
        method = "GET";
      }
      var xhr = new XMLHttpRequest();
      xhr.open(method, actionUrl, true);

      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(xhr.response);
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText,
          });
        }
      };
      xhr.onerror = function () {
        reject({
          status: this.status,
          statusText: xhr.statusText,
        });
      };
      xhr.send(data);
    });
  },

  AsyncGetRequest: (actionUrl, method) => {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(method, actionUrl, true);
      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          //console.log(xhr);
          resolve(xhr.response);
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText,
          });
        }
      };
      xhr.onerror = function () {
        reject({
          status: this.status,
          statusText: xhr.statusText,
        });
      };
      xhr.send();
    });
  },
};

export default HttpClient;
